var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { localStorageKeys } from '../common/constants/local.storage.keys';
var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
    }
    LocalStorageService.setLocalStorageKeySubfix = function (key, hubName, userID, shared) {
        var subfix = userID ? key + "_" + hubName + "_" + userID : key + "_" + hubName;
        subfix = shared ? subfix + '_shared' : subfix;
        subfix += '_v2';
        return subfix;
    };
    LocalStorageService.getLocalStorageKeyForVisitorTrip = function (hubName, userFacebookID, isShared) {
        if (userFacebookID === void 0) { userFacebookID = ''; }
        if (isShared === void 0) { isShared = false; }
        var key = LocalStorageService.setLocalStorageKeySubfix(localStorageKeys.visitorTrip, hubName, userFacebookID, isShared);
        return key;
    };
    LocalStorageService.getAllBackendSettingsFromLocalStorage = function () {
        var allSettingsStr = localStorage.getItem(localStorageKeys.allBackendSettings);
        if (!allSettingsStr) {
            console.error('No settings found');
            return null;
        }
        var allSettings = JSON.parse(allSettingsStr);
        return allSettings;
    };
    LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage = function () {
        var allSettings = this.getAllBackendSettingsFromLocalStorage();
        if (!allSettings.customSettings.customDefaultPlaceCategory) {
            console.error('No custom default place categories found');
            return null;
        }
        return __assign({}, allSettings.customSettings.customDefaultPlaceCategory, { mergedDefaultCategories: allSettings.mergedDefaultCategories, businessType: allSettings.customSettings.dataSource.businessType, toggle: allSettings.toggle, blockGooglePlaceCategories: allSettings.blockGooglePlaceCategories });
    };
    return LocalStorageService;
}());
export { LocalStorageService };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/localStorageService.ts.pre-build-optimizer.js